import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const cardContent = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
};
export const CardIcon = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardInfo = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 80%;
`;

export const BadgeTitle = styled.p`
  font-weight: bold;
  margin: 0;
  padding: 0;
`;

export const BadgeDescription = styled.p`
  color: ${colors.GRAY_DARKER};
  margin: 0;
  padding: 0;
`;

export default {
  cardContent,
  CardIcon,
  CardInfo,
  BadgeTitle,
  BadgeDescription,
};
